<template>
  <div class="rj-page-card">
    <div class="rj-page-card__title">审批意见</div>
    <div class="rj-page-card__content">
      <el-table :data="approveLogList" border empty-text="暂无审批意见">
        <el-table-column prop="rapproveUserName" label="审批人" width="180" />
        <el-table-column prop="rapproveType" label="操作" width="120">
          <template slot-scope="scope">{{ actionLabel(scope.row.rapproveType) }}</template>
        </el-table-column>
        <el-table-column prop="rapproveContent" label="审批意见" />
        <el-table-column prop="rcreatedTime" label="审批时间" width="180" />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesBorrowHistory',
  props: { approveLogList: { type: Array, default: () => [] } },
  methods: {
    actionLabel (action) {
      return {
        submit: '提交',
        reject: '驳回',
        agree: '通过',
        recall: '召回',
        erp_success: 'ERP抛单成功'
      }[action] || action;
    }
  }
};
</script>
